import { Baby } from "lucide-react"
import { cn } from "@/shared/lib/utils"
import { sexTint } from "./children.config"
import { useSelectedChild } from "./useSelectedChild"

export function ChildSwitcher() {
  const { selectedChild } = useSelectedChild()
  if (!selectedChild) return null

  return (
    <div className="flex items-center gap-1.5 rounded-full border-2 border-primary bg-card/80 px-3 py-1.5 text-sm backdrop-blur-md">
      <Baby className={cn("size-4", sexTint(selectedChild.sex))} />
      <span className="max-w-40 truncate">{selectedChild.name}</span>
    </div>
  )
}
